"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticated = exports.Anonymous = void 0;
const node_fetch_1 = require("node-fetch");
class Anonymous {
    constructor(config) {
        this.config = config;
    }
    post(path, data) {
        return postData(Object.assign(Object.assign({}, this.config), { path, data }));
    }
}
exports.Anonymous = Anonymous;
class Authenticated {
    constructor(config) {
        this.config = config;
    }
    post(path, data) {
        return postData(Object.assign(Object.assign({}, this.config), { path,
            data, extraHeaders: { Authorization: 'Token token=' + this.config.authToken } }));
    }
}
exports.Authenticated = Authenticated;
function postData(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = Object.assign(Object.assign({}, options.extraHeaders), { Accept: 'application/json', 'Content-Type': 'application/json' });
        const body = JSON.stringify(Object.assign(Object.assign({}, options.data), { source: options.source, client_id: options.clientId }));
        const url = joinUrl(options.baseUrl, options.path);
        try {
            const res = yield node_fetch_1.default(url, {
                method: 'POST',
                headers: headers,
                body: body
            });
            if (res.ok) {
                const data = yield res.json();
                return { type: 'ok', data };
            }
            else {
                console.log('API request failed, status:', res.status);
                return { type: 'server_error' };
            }
        }
        catch (e) {
            console.log('API request failed, error:', e);
            return { type: 'network_error' };
        }
    });
}
function joinUrl(root, path) {
    if (root.endsWith('/')) {
        return root + path;
    }
    else {
        return root + '/' + path;
    }
}
